import React, { useEffect, useRef, useState } from "react";
import { topicMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import MainPopup from "../popup-containers/MainPopup";
import toast from "react-hot-toast";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import TextArea from "../ReusableComponents/TextArea";
import TextEditor from "../ReusableComponents/TextEditor";
import { IoInformationCircle } from "react-icons/io5";
import TopicPopup from "../popup-containers/TopicPopup";
import Loader from "../ReusableComponents/Loader";

const Topic = () => {
  const location = useLocation();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [helpPopUpOpen, setHelpPopUpOpen] = useState(false);
  const [helpPopUpOpen1, setHelpPopUpOpen1] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const popupRef1 = useRef(null);
  const popupRef2 = useRef(null);
  const [mstTopicId, setMstTopicId] = useState("");
  const [topicData, setTopicData] = useState({});
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  const [rowIndex, setRowIndex] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [topicData2, setTopicData2] = useState({});

  const [bindTopicMasterDatas, setBindTopicMasterDatas] = useState([]);
  const [topicNoDatas, setTopicNoDatas] = useState([]);
  const [topicFields, setTopicFields] = useState({
    module: "",
    topicNo: "",
    topic: "",
    topicName: "",
    topicInformation: "",
    topicGuidance: "",
    remarks: "",
  });

  const [topicFieldsError, setTopicFieldsError] = useState({
    moduleError: "",
    topicNoError: "",
    topicNameError: "",
    topicInformationError: "",
    topicGuidanceError: "",
  });

  const [moduleBindDD, setModuleBindDD] = useState([]);
  const bindDropDownDatas = async () => {
    try {
      const response = await BindAPI("MasterDataAPI/BindMasterDatas");
      if (response.data.Table.length > 0) {
        const moduleDD = response.data.Table.map((m) => ({
          value: m.MstModuleId,
          label: m.ModuleName,
        }));
        setModuleBindDD(moduleDD);
      } else {
        setModuleBindDD([]);
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
  };

  const handleTopicFieldsChange = (value, name) => {
    setTopicFields({
      ...topicFields,
      [name]: value,
    });
  };
  // Close popup on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef1.current && !popupRef1.current.contains(event.target)) {
        setHelpPopUpOpen(false);
      }

      if (popupRef2.current && !popupRef2.current.contains(event.target)) {
        setHelpPopUpOpen1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [helpPopUpOpen, helpPopUpOpen1]);

  useEffect(() => {
    const fetchData = async () => {
      bindDropDownDatas();
    };
    fetchData();
  }, []);
  // Close popup on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef1.current && !popupRef1.current.contains(event.target)) {
        setHelpPopUpOpen(false);
      }

      if (popupRef2.current && !popupRef2.current.contains(event.target)) {
        setHelpPopUpOpen1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [helpPopUpOpen, helpPopUpOpen1]);
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true); // Add Screen title & button
    setUpdateScreenTitle(false); // Update Screen title & button
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    setTopicFields({ ...topicFields, date: formattedDate });
    localStorage.setItem("screenMode", "add");
  };
  const cancel = () => {
    setIsLoading(false);
    fetchTopic();
    setVisibleAdd(false);
    setVisibleTable(true);
    setSubmitBtnDisabled(false);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    clear();
    localStorage.setItem("screenMode", "");
  };
  const clear = () => {
    setTopicFields({
      module: "",
      topicNo: "",
      topic: "",
      topicName: "",
      topicInformation: "",
      topicGuidance: "",
      remarks: "",
    });
    setTopicFieldsError({
      moduleError: "",
      topicNoError: "",
      topicNameError: "",
      topicInformationError: "",
      topicGuidanceError: "",
    });
  };
const fetchTopic = async () => {
  try {
    setIsLoading(true);
    const { data } = await BindAPI("TopicAPI/BindTopics");

    setBindTopicMasterDatas(data?.Table ?? []);
    setTopicNoDatas(data?.Table1 ?? []);
        if (data?.Table.length > 0) {
      setVisibleTable(true);
      setVisibleAdd(false);
    } else {
      showAdd();
    }
  } catch (error) {
    console.error("Error fetching topics:", error);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  fetchTopic();
}, []);


  const handleEdit = async (rowIndex) => {
    setEditMode(true);
    setSelectedRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(true);
    setAddScreenTitle(false);
    localStorage.setItem("screenMode", "edit");
    localStorage.setItem("selectedRowIndex", rowIndex);
    setTopicFields({
      ...topicFields,
      module: bindTopicMasterDatas[rowIndex].MstModuleId,
      topicNo: bindTopicMasterDatas[rowIndex].TopicNo,
      topicName: bindTopicMasterDatas[rowIndex].TopicName,
      topicInformation: bindTopicMasterDatas[rowIndex].TopicInformation,
      topicGuidance: bindTopicMasterDatas[rowIndex].TopicGuidance,
      remarks: bindTopicMasterDatas[rowIndex].Remarks,
    });

    setMstTopicId(bindTopicMasterDatas[rowIndex].MstTopicId);
  };
  const handleTopic = (rowIndex, flag) => {
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }

    setTopicData(bindTopicMasterDatas[rowIndex]);
    const moduleRowData = bindTopicMasterDatas[rowIndex];
    const moduleInfo = moduleBindDD.find(
      (ST) => ST.value === moduleRowData.MstModuleId
    );
    const resultModule = {
      value: moduleRowData.MstModuleId,
      label: moduleInfo ? moduleInfo.label : "",
    };

    const TopicData2 = [resultModule];

    setTopicData2(TopicData2);
  };

  const createdBy = sessionStorage.getItem("createdBy");
  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    if (flag == 1 || flag == 2) {
      const plainText = topicFields.topicInformation
        .replace(/<(.|\n)*?>/g, "")
        .trim();
      const plainText1 = topicFields.topicGuidance
        .replace(/<(.|\n)*?>/g, "")
        .trim();
      const isFormError = {
        ...topicFieldsError,
        moduleError: topicFields.module ? "" : "Select Module",
        topicNoError:
          topicFields.topicNo && topicFields.topicNo.length > 0
            ? !updateScreenTitle &&
              topicNoDatas.find(
                (x) =>
                  x.TopicNo.toLowerCase() === topicFields.topicNo.toLowerCase()
              )
              ? "Already Exists Topic No."
              : ""
            : "Enter Topic No.",
        topicNameError: topicFields.topicName ? "" : "Select Topic Name",
        topicInformationError:
          plainText.length > 0 ? "" : "Enter Topic Information ",
        topicGuidanceError:
          plainText1.length > 0 ? "" : "Enter Topic Guidance ",
      };
      setTopicFieldsError(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );
      if (isFormValid) {
        setIsLoading(true);
        setSubmitBtnDisabled(true);
        const topicPayload = [
          {
            mstTopicId: mstTopicId ? mstTopicId : 0,
            mstModuleId: topicFields.module,
            topicNo: topicFields.topicNo,
            topicName: topicFields.topicName,
            topicInformation: topicFields.topicInformation,
            topicGuidance: topicFields.topicGuidance,
            remarks: topicFields.remarks,
            createdby: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(topicPayload, "TopicAPI/IUDtopics");
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Topic added successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed to add Topic data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Topic updated successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed to update Questions data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setIsLoading(false);
        setIsOpen(true);
        setSubmitBtnDisabled(false);
      }
    } else {
      const data = {
        mstTopicId: bindTopicMasterDatas[items].MstTopicId,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "TopicAPI/IUDtopics");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Topic data deleted successfully 🗑️", 5000, cancel());
        } else {
          toast.error("Failed to delete Topic data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Topic data active successfully 🚫", 5000, cancel());
          cancel();
        } else {
          toast.error("Failed to active Topic data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Topic data inactive successfully ✅", 5000, cancel());
          cancel();
        } else {
          toast.error("Failed to inactive Topic data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
  };

  useEffect(() => {
    if (location.pathname === "/topic") {
      const screenMode = localStorage.getItem("screenMode");
      if (screenMode === "add") {
        setVisibleAdd(true);
        setVisibleTable(false);
        setAddScreenTitle(true);
        setUpdateScreenTitle(false);
      } else if (screenMode === "edit") {
        const storedIndex = localStorage.getItem("selectedRowIndex");
        if (storedIndex !== null && bindTopicMasterDatas.length > 0) {
          handleEdit(Number(storedIndex));
        }
      }
    }
  }, [location, bindTopicMasterDatas]);

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && !isLoading &&(
        <GridPage
          title="Topic"
          header={topicMasterHeader}
          records={bindTopicMasterDatas}
          blockView={true}
          downloadView={false}
          handleEdit={handleEdit}
          handleAction={handleTopic}
          showAdd={showAdd}
        />
      )}
      {visibleAdd && (
        <div class=" flex flex-col w-full">
          <div class={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Topic"
            />
            <div class={mainTable.addShadowScreen}>
              <div class={mainTable.mainContentScreen}>
                <form class={mainTable.formForClientMaster}>
                  <div class={mainTable.grid3}>
                    <AutoDropDown
                      title="Module"
                      options={moduleBindDD}
                      placeholder="Select"
                      name="module"
                      selectedOption={moduleBindDD.find(
                        (x) => x.value == topicFields.module
                      )}
                      Class="custom-class"
                      tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleTopicFieldsChange(value.value, e.name);
                        setTopicFields({
                          ...topicFields,
                          module: value.value,
                        });
                        setTopicFieldsError({
                          ...topicFieldsError,
                          moduleError: value ? "" : "Select Module",
                        });
                      }}
                      controlFuncBlur={() => {
                        setTopicFieldsError(() => ({
                          ...topicFieldsError,
                          moduleError: topicFields.module
                            ? ""
                            : "Select Module",
                        }));
                      }}
                      errorMessage={topicFieldsError.moduleError}
                    />
                    <InputText
                      inputType={"text"}
                      title={"Topic No."}
                      name={"topicNo"}
                      classStar={"text-red-500"}
                      maxLength={100}
                      content={topicFields.topicNo}
                      disabled={updateScreenTitle}
                      controlFunc={(e) =>
                        setTopicFields({
                          ...topicFields,
                          topicNo: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setTopicFieldsError((topicFieldsError) => ({
                          ...topicFieldsError,
                          topicNoError:
                            topicFields.topicNo &&
                            topicFields.topicNo.length > 0
                              ? !updateScreenTitle &&
                                topicNoDatas.find(
                                  (x) =>
                                    x.TopicNo.toLowerCase() ===
                                    topicFields.topicNo.toLowerCase()
                                )
                                ? "Already Exists Topic No."
                                : ""
                              : "Enter Topic No.",
                        }));
                      }}
                      errorMessage={topicFieldsError.topicNoError}
                    />

                    <InputText
                      inputType={"text"}
                      title={"Topic Name"}
                      name={"topicName"}
                      classStar={"text-red-500"}
                      maxLength={100}
                      content={topicFields.topicName}
                      controlFunc={(e) =>
                        setTopicFields({
                          ...topicFields,
                          topicName: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setTopicFieldsError((topicFieldsError) => ({
                          ...topicFieldsError,
                          topicNameError:
                            topicFields.topicName &&
                            topicFields.topicName.length > 0
                              ? ""
                              : "Enter Topic Name",
                        }));
                      }}
                      errorMessage={topicFieldsError.topicNameError}
                    />
                    <div className="mt-2 col-span-3">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        <span className="">Topic Information</span>{" "}
                        <div className="relative inline-flex items-center">
                          <IoInformationCircle
                            className="text-2xl text-black cursor-pointer ml-1"
                            onMouseOver={() => {
                              setHelpPopUpOpen(true);
                            }}
                            onMouseOut={() => {
                              setHelpPopUpOpen(false);
                            }}
                          />
                          <span className={"text-red-500"}>*</span>
                          {helpPopUpOpen && (
                            <div
                              ref={popupRef1}
                              className="absolute left-full top-1 ml-2 bg-gray-200 text-black text-sm rounded-lg px-4 py-3 shadow-md max-w-xs md:w-96 z-10"
                            >
                              <div className="absolute -left-2 top-4 w-4 h-4 bg-gray-200 transform rotate-45"></div>
                              <p className="max-lg:mt-1 mx-2 lg:mx-4 text-xs italic font-normal">
                                This text will appear in the information icon of
                                the Topic
                              </p>
                            </div>
                          )}
                        </div>
                      </label>
                      <TextEditor
                        value={topicFields.topicInformation}
                        name="topicInformation"
                        onChange={(value) => {
                          const plainText = value
                            .replace(/<(.|\n)*?>/g, "")
                            .trim();
                          setTopicFields((prev) => ({
                            ...prev,
                            topicInformation: value,
                          }));
                          setTopicFieldsError((prev) => ({
                            ...prev,
                            topicInformationError:
                              plainText.length > 0
                                ? ""
                                : prev.topicInformationError,
                          }));
                        }}
                        onBlur={({ target }) => {
                          const plainText = target.value
                            .replace(/<(.|\n)*?>/g, "")
                            .trim();
                          setTopicFieldsError((prev) => ({
                            ...prev,
                            topicInformationError:
                              plainText.length > 0
                                ? ""
                                : "Enter Topic Information",
                          }));
                        }}
                        error={topicFieldsError.topicInformationError}
                      />
                    </div>
                    <div className="mt-2 col-span-3">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        <span className="">Topic Guidance</span>{" "}
                        <div className="relative inline-flex items-center ml-1">
                          <IoInformationCircle
                            className="text-2xl text-black cursor-pointer"
                            onMouseOver={() => {
                              setHelpPopUpOpen1(true);
                            }}
                            onMouseOut={() => {
                              setHelpPopUpOpen1(false);
                            }}
                          />
                          <span className={"text-red-500"}>*</span>
                          {helpPopUpOpen1 && (
                            <div
                              ref={popupRef2}
                              className="absolute left-full top-1 ml-2 bg-gray-200 text-black rounded-lg px-4 py-3 shadow-md max-w-xs md:w-96 z-10"
                            >
                              <div className="absolute -left-2 top-4 w-4 h-4 bg-gray-200 transform rotate-45"></div>
                              <p className="max-lg:mt-1 mx-2 lg:mx-4 text-xs italic font-normal">
                                This text will appear as a guidance underneath
                                the question.
                              </p>
                            </div>
                          )}
                        </div>
                      </label>
                      <TextEditor
                        value={topicFields.topicGuidance}
                        name="topicGuidance"
                        onChange={(value) => {
                          const plainText = value
                            .replace(/<(.|\n)*?>/g, "")
                            .trim();
                          setTopicFields((prev) => ({
                            ...prev,
                            topicGuidance: value,
                          }));
                          setTopicFieldsError((prev) => ({
                            ...prev,
                            topicGuidanceError:
                              plainText.length > 0
                                ? ""
                                : prev.topicGuidanceError,
                          }));
                        }}
                        onBlur={({ target }) => {
                          const plainText = target.value
                            .replace(/<(.|\n)*?>/g, "")
                            .trim();
                          setTopicFieldsError((prev) => ({
                            ...prev,
                            topicGuidanceError:
                              plainText.length > 0
                                ? ""
                                : "Enter Topic Guidance",
                          }));
                        }}
                        error={topicFieldsError.topicGuidanceError}
                      />
                    </div>
                    <div class="col-span-3">
                      <TextArea
                        title={"Remarks"}
                        name={`remarks`}
                        content={topicFields.remarks}
                        controlFunc={(e) =>
                          setTopicFields({
                            ...topicFields,
                            remarks: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </form>
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="Topic"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <TopicPopup data={topicData} data1={topicData2} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Topic;
